import React from "react";
import { useNavigate } from "react-router-dom";

const Header = () => {
    const navigate = useNavigate();

    // Style objek
    const headerStyle = {
        width: "100%",
        padding: "15px 20px",
        backgroundColor: "#007bff",
        color: "white",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    };

    const logoStyle = {
        fontSize: "20px",
        fontWeight: "bold",
        cursor: "pointer",
    };

    const navStyle = {
        display: "flex",
        gap: "15px",
    };

    const navItemStyle = {
        color: "white",
        textDecoration: "none",
        fontSize: "16px",
        cursor: "pointer",
    };

    return (
        <header style={headerStyle}>
            <div style={logoStyle} onClick={() => navigate("/")}>
                MyApp
            </div>
            <nav style={navStyle}>
                <span style={navItemStyle} onClick={() => navigate("/")}>Home</span>
                <span style={navItemStyle} onClick={() => navigate("/login")}>Login</span>
                <span style={navItemStyle} onClick={() => navigate("/register")}>Register</span>
            </nav>
        </header>
    );
};

export default Header;
